export default __webpack_public_path__ + "static/media/bg2.68068284.png";